import { getFilterIndicator } from "../helpers";

import type { FilterStrategy } from "./types";

export const idStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (!filterType.prefix) return;
    const prefix = filterType.prefix.toLowerCase();
    const queryLower = ctx.trimmedQuery.toLowerCase();
    const prefixWithUnderscore = prefix + "_";
    const prefixWithDash = prefix + "-";

    const matchesPrefix =
      queryLower.startsWith(prefix) ||
      prefix.startsWith(queryLower) ||
      queryLower.startsWith(prefixWithUnderscore) ||
      queryLower.startsWith(prefixWithDash);

    if (!matchesPrefix) return;
    out.push({
      filterKey: filterType.filterKey,
      filterLabel: filterType.label,
      optionValue: ctx.trimmedQuery,
      optionLabel: `~ "${ctx.trimmedQuery}"`,
      type: filterType.type,
      score: 85,
      indicator: getFilterIndicator(filterType, false, true),
    });
  },
  isSelected(currentValue, optionValue) {
    return Array.isArray(currentValue)
      ? currentValue.includes(optionValue)
      : currentValue === optionValue;
  },
  toggle(result) {
    return { value: result.optionValue, clearSearchQuery: true };
  },
};
